// Offline support for the Daily Report: when a save can't reach the API the
// full payload is stashed in localStorage, keyed by reportId (latest write
// wins — payloads are whole-report upserts, so replaying only the newest one
// per report is correct). The queue flushes automatically when the browser
// comes back online, and once on load.

const QUEUE_KEY = 'fieldReportOfflineQueue';

export const readQueue = () => {
    try { return JSON.parse(localStorage.getItem(QUEUE_KEY)) || {}; } catch (_) { return {}; }
};

const writeQueue = (q) => {
    try { localStorage.setItem(QUEUE_KEY, JSON.stringify(q)); } catch (_) { /* storage full — nothing else to do */ }
};

export const queueSave = (payload) => {
    const q = readQueue();
    q[payload.report.reportId] = { payload, queuedAt: new Date().toISOString() };
    writeQueue(q);
};

export const dequeueSave = (reportId) => {
    const q = readQueue();
    delete q[reportId];
    writeQueue(q);
};

export const queuedCount = () => Object.keys(readQueue()).length;

export const queuedFor = (reportId) => readQueue()[reportId] || null;

// Replay every queued payload through saveFn (api saveFieldReport). Entries
// that land are removed; failures stay queued for the next flush.
export const flushQueue = async (saveFn) => {
    const q = readQueue();
    let sent = 0;
    let failed = 0;
    for (const [id, item] of Object.entries(q)) {
        try {
            const res = await saveFn(item.payload);
            if (res && !res.error) { dequeueSave(id); sent += 1; } else failed += 1;
        } catch (_) {
            failed += 1;
        }
    }
    return { sent, failed };
};
